import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { links } from "../data/content";
import { button, eyebrow, shell } from "../utils/styles";
export function Closing() {
  return <section className={`${shell} pb-[55px] text-center sm:pb-[75px] sm:pt-[30px]`} data-id="element-18" data-mp="3f9mcr7mcsje8">
      <p className={eyebrow} data-id="element-19" data-mp="3jay71qg69ssr">Tu próximo paso</p>
      <h2 className="mx-auto mb-7 max-w-3xl font-display text-[37px] font-medium leading-[1.15] tracking-[-1.5px] sm:text-[52px] sm:tracking-[-2px]" data-id="element-20" data-mp="3j9n4tv2dkt3r">
        Empezá a trabajar en tu propio <em className="not-italic text-lime" data-id="element-21" data-mp="3aajj0jbtpzlk">ebook</em>
      </h2>
      <a href="#unirme" className={button} data-id="element-22" data-mp="2wai96edkzhty">
        Quiero entrar con precio fundador
        <ArrowRightIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-23" data-mp="2wcv03h1bh2j5" />
      </a>
      <p className="mt-[25px] text-[11px] leading-[1.9] text-muted" data-id="element-24" data-mp="30cdjg8dhp5jv">
        ¿Todavía no querés comprar?{" "}
        <a href={links.whatsapp} target="_blank" rel="noopener noreferrer" className="block text-[#c8d8b6] underline underline-offset-4 sm:inline" data-id="element-25" data-mp="uh11japgagz7">
          Sumate gratis al grupo de WhatsApp
        </a>
      </p>
    </section>;
}